// src/pages/ResetPassword.jsx
import React, { useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import api from "../api/api";

export default function ResetPassword() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token") || "";
  const [form, setForm] = useState({ new_password: "", confirm_password: "" });
  const [done, setDone] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    if (form.new_password !== form.confirm_password) {
      setError("Passwords do not match.");
      return;
    }
    if (form.new_password.length < 8) {
      setError("Password must be at least 8 characters.");
      return;
    }
    setLoading(true);
    try {
      await api.post("/auth/reset-password", {
        token,
        new_password: form.new_password,
      });
      setDone(true);
    } catch (err) {
      setError(err.response?.data?.detail || "Reset failed. The link may have expired.");
    } finally {
      setLoading(false);
    }
  };

  if (!token) {
    return (
      <div className="login-container" style={{ margin: "2rem auto", textAlign: "center" }}>
        <h2>Invalid Reset Link</h2>
        <p style={{ color: "red" }}>No reset token found. Please request a new password reset.</p>
        <p><Link to="/forgot-password">Request reset</Link></p>
      </div>
    );
  }

  return (
    <div className="login-container" style={{ margin: "2rem auto", textAlign: "center" }}>
      <div className="logo-slot" style={{ marginBottom: "1rem" }}>
        <img src="/logo.png" alt="CardStoard Logo" style={{ width: "550px", height: "auto" }} />
      </div>

      <h2>Reset Password</h2>

      {done ? (
        <div style={{ maxWidth: 320, margin: "0 auto" }}>
          <p style={{ color: "#2e7d32" }}>Password updated successfully.</p>
          <p style={{ marginTop: "1rem" }}>
            <Link to="/login">Log in with your new password</Link>
          </p>
        </div>
      ) : (
        <form
          onSubmit={handleSubmit}
          style={{ display: "flex", flexDirection: "column", gap: "1rem",
                   alignItems: "center", maxWidth: "320px", margin: "0 auto" }}
        >
          <input
            type="password"
            placeholder="New password"
            value={form.new_password}
            onChange={e => setForm({ ...form, new_password: e.target.value })}
            required
            style={{ width: "100%", padding: "0.5rem" }}
          />
          <input
            type="password"
            placeholder="Confirm new password"
            value={form.confirm_password}
            onChange={e => setForm({ ...form, confirm_password: e.target.value })}
            required
            style={{ width: "100%", padding: "0.5rem" }}
          />
          <button
            type="submit"
            className="nav-btn"
            style={{ padding: "0.75rem", fontSize: "1rem", width: "100%" }}
            disabled={loading}
          >
            {loading ? "Updating..." : "Set New Password"}
          </button>
          {error && <p style={{ color: "red" }}>{error}</p>}
        </form>
      )}
    </div>
  );
}
